import { ActivityService } from './../../services/activity.service';
import { Component, OnInit } from '@angular/core';
import { Activity } from '../../models/activity';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItems } from '../../../../../shared/Models/SelectItems';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreateActivityComponent implements OnInit {
  activity: Activity = {} as Activity;
  activityTypesOptions: SelectItems[];

  constructor(private service: ActivityService, private route: ActivatedRoute, private router: Router) {
    this.activity.phaseId = this.route.snapshot.params.id;
  }

  ngOnInit() {
    this.loadRequiredCreateDate();
  }
  loadRequiredCreateDate() {
    this.service.getCreateNew().subscribe((res) => {
      this.activityTypesOptions = res[0].values;
    });
  }
  dropdownChange($event) {}
  save() {
    this.activity.flgType = 1;
    this.service.post(this.activity).subscribe((res) => {});
  }
  back() {
    const route = ['workflow'];
    this.router.navigate(route);
  }
}
